import React from 'react'

import { Field } from 'formik'

import { Col, Row, Form } from '_zari/core'

import { ModalidadCalculoIsla } from 'constants/index'

const ModalidadCalculoIslaFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <>
      <Row>
        <Col md={2}>
          <Field name='modalidadCalculoIsla'>
            {({ field }) => (
              <Form.Radio
                {...field}
                id='radio-modalidadCalculo-M'
                label='S /.'
                value={ModalidadCalculoIsla.MONTO_TOTAL}
                checked={iValue === ModalidadCalculoIsla.MONTO_TOTAL}
                disabled={fIsSubmitting}
              />
            )}
          </Field>
        </Col>
        <Col md={2}>
          <Field name='modalidadCalculoIsla'>
            {({ field }) => (
              <Form.Radio
                {...field}
                id='radio-modalidadCalculo-G'
                label='Galones'
                value={ModalidadCalculoIsla.GALONES}
                checked={iValue === ModalidadCalculoIsla.GALONES}
                disabled={fIsSubmitting}
              />
            )}
          </Field>
        </Col>
      </Row>
    </>
  )
}

export default React.memo(ModalidadCalculoIslaFormGroup)
